var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-layout',[_c('popup-delivery-list',{attrs:{"delivery-list":_vm.deliveryList},on:{"set-delivery-location":_vm.chooseDeliveryLocation,"dispose":_vm.onDispose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }